<template>

    <section id="about-section">
      <div class="container">
        <div class="title-section">
          <h1>{{data.title}}</h1>
          <span></span>
          <p>{{data.description}}</p>
        </div>

        <div class="about-box">
          <div class="row">
            <div class="col-md-4" v-for="(item, index) in data.subtext">
              <div class="about-post">
                <a href="#"><i :class="'fa '+item.icon"></i></a>
                <h2>{{item.title}}</h2>
                <p>{{item.subtitle}}</p>
              </div>
            </div>
    
          </div>
        </div>

      </div>
    </section>
</template>

<script>
export default {
  name: 'About',
  props: {
    data: Object
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
